/* eslint-disable @typescript-eslint/naming-convention */
import { RouterModule, Routes } from '@angular/router';
import { ContactDetailsScreenComponent } from './screens/contact-details-screen/contact-details-screen.component';
import { RegisterDisclaimerScreenComponent } from './screens/register-disclaimer-screen/register-disclaimer-screen.component';
import { RegisterLicenseScreenComponent } from './screens/register-license-screen/register-license-screen.component';
import { RegisterScreenComponent } from './screens/register-screen/register-screen.component';

export const UserManagementRoutes: Routes = [
    { path: 'new', component: RegisterScreenComponent },
    { path: 'register-contact-detail', component: ContactDetailsScreenComponent },
    { path: 'register-declare-license', component: RegisterLicenseScreenComponent },
    { path: 'register-termsofuse', component: RegisterDisclaimerScreenComponent },
    { path: '', redirectTo: 'new', pathMatch: 'full' },
    { path: '**', redirectTo: '/404' }

];

export const UserManagementRoutingModule = RouterModule.forChild(
    UserManagementRoutes
);
